import { datesToISO, formatTime, formatDate } from "@";

// enums options
export const enumsOptions = (enums) => {
  if (!enums) return [];
  return enums?.map((item) => {
    return { name: item.Arabic, value: item.Id };
  });
};

// save payload for message
export const savePayload = (data) => ({
  name: data.name,
  amountTo: parseInt(data.amountTo),
  frequency: parseInt(data.frequency),
  messageContent: data.messageContent,
  amountFrom: parseInt(data.amountFrom),
  messageType: parseInt(data.messageType),
  customerType: parseInt(data.customerType),
  orderCountTo: parseInt(data.orderCountTo),
  messageTime: formatTime(data.messageTime),
  messageDate: formatDate(data.messageDate),
  affiliateUrlPrefix: data.affiliateUrlPrefix,
  joiningPeriod: parseInt(data.joiningPeriod),
  orderCountFrom: parseInt(data.orderCountFrom),
  project: data?.project?.value
    ? {
        projectId: data?.project.value,
        projectType: data?.project.projectType,
      }
    : null,
});

// search values payload for messages
export const searchValuesPayload = (page, pageSize, search) => ({
  page: page,
  pageSize: pageSize,
  searchKey: search.title,
  toDate: datesToISO(search.toDate),
  fromDate: datesToISO(search.fromDate),
  messageType: parseInt(search.messageType),
  messageStatus: parseInt(search.messageStatus),
});
